import React from "react"
import { View, Text } from "react-native";
import CloverPoint from "types/models/CloverPoint";
import CloverConnectionChart from "./CloverConnectionChart";
import { useTranslation } from "react-i18next";
import CloverConnectionPaperChart from "./CloverConnectionPaperChart";
import { colors } from "../../config";
import { StyleSheet } from "react-native";
import { useCloverPoints } from "hooks/useCloverPointStatus";
import CloverConnectionStatuses from "./CloverConnectionStatuses";
import CloverConnectionStatusesTypes from "types/models/CloverConnectionStatuses";

export default ({ cloverPoints, mediumScreen }: { cloverPoints: CloverPoint[] | null, mediumScreen: boolean }): JSX.Element => {

    const { t } = useTranslation();
    const { cloverStatusesCount } = useCloverPoints({currentVenue: null});

    const [cloverPointStatuses, setCloverPointStatuses] = 
    React.useState<CloverConnectionStatusesTypes>
    ({online: 0, unstable: 0, offline: 0, whitoutPaper: 0, isInactive: 0});

    React.useEffect(() => {
        setCloverPointStatuses(cloverStatusesCount(null, cloverPoints as CloverPoint[]));
    }, [cloverPoints]);

    return (
        <View style={styles.container}>
            {mediumScreen ? (
                <>
                <View style={styles.gaphicContainer}>
                    <Text style={styles.title}>{t('clover-connection-status.connection-statuses')}</Text>
                    <CloverConnectionChart cloverPointStatuses={cloverPointStatuses} t={t}/>
                    <View style={styles.colorIndicatorContainer}>
                        <View style={styles.colorIndicatorContainer}>
                            <View style={{...styles.colorIndicatorItem, backgroundColor: colors.cloverConnected}}></View>
                            <Text style={styles.colorIndicatorText}>{t('clover-connection-status.connected')}</Text>
                        </View>

                        <View style={styles.colorIndicatorContainer}>
                            <View style={{...styles.colorIndicatorItem, backgroundColor: colors.cloverUnstable}}></View>
                            <Text style={styles.colorIndicatorText}>{t('clover-connection-status.unstable')}</Text>
                        </View>

                        <View style={styles.colorIndicatorContainer}>
                            <View style={{...styles.colorIndicatorItem, backgroundColor: colors.cloverDisconnected}}></View>
                            <Text style={styles.colorIndicatorText}>{t('clover-connection-status.disconnected')}</Text>
                        </View>

                        <View style={styles.colorIndicatorContainer}>
                            <View style={{...styles.colorIndicatorItem, backgroundColor: colors.black}}></View>
                            <Text style={styles.colorIndicatorText}>{t('clover-connection-status.inactive')}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.gaphicContainer}>
                    <Text style={styles.title}>{t('clover-connection-status.paper-statuses')}</Text>
                    <CloverConnectionPaperChart cloverPointStatuses={cloverPointStatuses} t={t}/>
                </View>
                </>
            ) : (
                <View style={styles.gaphicContainer}>
                    <CloverConnectionStatuses cloverPointStatuses={cloverPointStatuses} navigation={null} isForVenue={true} isForReports={true}/>
                </View>
            )}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row', 
        justifyContent: 'space-around', 
        marginVertical: 20
    },
    gaphicContainer: {
        width: '45%', 
        justifyContent: 'center', 
        alignItems: 'center'
    },
    title: {
        fontWeight: 'bold', 
        fontSize: 20, 
        color: '#aaaaaaff'
    },
    colorIndicatorContainer: { 
        flexDirection: 'row', 
        justifyContent: 'space-between',
        marginTop: 20
    },
    colorIndicatorItem: { 
        width: 20, 
        height: 20, 
        borderRadius: 100,
    },
    colorIndicatorText: {
        fontWeight: '500', 
        fontSize: 14, 
        color: '#aaaaaaff',
        marginHorizontal: 10
    }
});